import { RESOURCE_TYPE } from '../data';

import { useAuthorization } from '.';

export const usePlatformAuthorization = () => {
  const { hasResourcePermission, isLoading } = useAuthorization({
    resourceType: RESOURCE_TYPE.PLATFORM,
  });

  return {
    hasPlatformPermission: (permissions?: string[]) => {
      return hasResourcePermission(permissions);
    },
    isLoading,
  };
};
